<template>
<div class="chapter">
<div class="inner_page">
<div class="boxnote1">
<h2 class="h2ca">C</h2>
<h2 class="h2c"><a id="page_vii"></a>Contents</h2>
</div>
<table border="0" cellpadding="0" cellspacing="0" width="100%">
<colgroup><col width="10%"/>
<col width="90%"/>
</colgroup><tbody><tr>
<td valign="bottom"><p class="toc1t"> </p></td>
<td valign="top"><p class="toc2t"><a href="#/xhtml/contributors#con">Contributors</a></p></td>
</tr>
<tr>
<td valign="bottom"><p class="toc1t"> </p></td>
<td valign="top"><p class="toc2t"><a href="#/xhtml/reviewers#rev">Reviewers</a></p></td>
</tr>
<tr>
<td valign="bottom"><p class="toc1t"> </p></td>
<td valign="top"><p class="toc2t"><a href="#/xhtml/preface#pre">Preface</a> · David A. Eberth and David C. Evans</p></td>
</tr>
<tr>
<td valign="bottom"><p class="toc1t"> </p></td>
<td valign="top"><p class="toc2t"><a href="#/xhtml/acknowledgments#ack">Acknowledgments</a></p></td>
</tr>
<tr>
<td valign="bottom"><p class="toc1t"> </p></td>
<td valign="top"><p class="toc2t"><strong><a href="#/xhtml/part01#part1">Part 1. Overview</a></strong></p></td>
</tr>
<tr>
<td valign="bottom"><p class="toc1t"><a href="#/xhtml/chapter01#ch1"><strong>1</strong></a></p></td>
<td valign="top"><p class="toc2t"><a href="#/xhtml/chapter01#ch1"><strong>A History of the Study of Ornithopods: Where Have We Been? Where Are We Now? and Where Are We Going?</strong></a></p></td>
</tr>
<tr>
<td valign="bottom"><p class="toc1"> </p></td>
<td valign="top"><p class="toc2">David B. Weishampel</p></td>
</tr>
<tr>
<td valign="bottom"><p class="toc1t"> </p></td>
<td valign="top"><p class="toc2t"><strong><a href="#/xhtml/part02#part2">Part 2. New Insights into Hadrosaur Origins</a></strong></p></td>
</tr>
<tr>
<td valign="bottom"><p class="toc1t"><a href="#/xhtml/chapter02#ch2"><strong>2</strong></a></p></td>
<td valign="top"><p class="toc2t"><a href="#/xhtml/chapter02#ch2"><strong>Iguanodonts from the Wealden of England: Do They Contribute to the Discussion Concerning Hadrosaur Origins?</strong></a></p></td>
</tr>
<tr>
<td valign="bottom"><p class="toc1"> </p></td>
<td valign="top"><p class="toc2">David B. Norman</p></td>
</tr>
<tr>
<td valign="bottom"><p class="toc1t"><a href="#/xhtml/chapter03#ch3"><strong>3</strong></a></p></td>
<td valign="top"><p class="toc2t"><a href="#/xhtml/chapter03#ch3"><strong>Osteology of the Basal Hadrosauroid <em>Equijubus normani</em> (Dinosauria, Ornithopoda) from the Early Cretaceous of China</strong></a></p></td>
</tr>
<tr>
<td valign="bottom"><p class="toc1"> </p></td>
<td valign="top"><p class="toc2">Andrew T. McDonald, Susannah C. R. Maidment, Paul M. Barrett, Hai-lu You, and Peter Dodson</p></td>
</tr>
<tr>
<td valign="bottom"><p class="toc1t"><span href="#/xhtml/chapter04#ch4" title="Link target outside of Sample"><strong>4</strong></span></p></td>
<td valign="top"><p class="toc2t"><span href="#/xhtml/chapter04#ch4" title="Link target outside of Sample"><strong><em>Gongpoquansaurus mazongshanensis</em> (Lü, 1997) comb. nov. (Ornithischia: Hadrosauroidea) from the Early Cretaceous of Gansu Province, Northwestern China</strong></span></p></td>
</tr>
<tr>
<td valign="bottom"><p class="toc1"> </p></td>
<td valign="top"><p class="toc2">Hai-lu You, Da-Qing Li, and Peter Dodson</p></td>
</tr>
<tr>
<td valign="bottom"><p class="toc1t"><span href="#/xhtml/chapter05#ch5" title="Link target outside of Sample"><strong>5</strong></span></p></td>
<td valign="top"><p class="toc2t"><span href="#/xhtml/chapter05#ch5" title="Link target outside of Sample"><strong>Postcranial Anatomy of a Basal Hadrosauroid (Dinosauria: Ornithopoda) from the Cretaceous (Cenomanian) Woodbine Formation of North Texas</strong></span></p></td>
</tr>
<tr>
<td valign="bottom"><p class="toc1"> </p></td>
<td valign="top"><p class="toc2">Derek J. Main, Christopher R. Noto, and David B. Weishampel</p></td>
</tr>
<tr>
<td valign="bottom"><p class="toc1t"><span href="#/xhtml/chapter06#ch6" title="Link target outside of Sample"><strong>6</strong></span></p></td>
<td valign="top"><p class="toc2t"><span href="#/xhtml/chapter06#ch6" title="Link target outside of Sample"><strong>A Re-evaluation of Purported Hadrosaurid Dinosaur Specimens from the “Middle” Cretaceous of England</strong></span></p></td>
</tr>
<tr>
<td valign="bottom"><p class="toc1"> </p></td>
<td valign="top"><p class="toc2">Paul M. Barrett, David C. Evans, and Jason J. Head</p></td>
</tr>
<tr>
<td valign="bottom"><p class="toc1t"><span href="#/xhtml/chapter07#ch7" title="Link target outside of Sample"><strong>7</strong></span></p></td>
<td valign="top"><p class="toc2t"><span href="#/xhtml/chapter07#ch7" title="Link target outside of Sample"><strong>A New Hadrosauroid (<em>Plesiohadros djadokhtaensis</em>) from the Late Cretaceous Djadokhtan Fauna of Southern Mongolia</strong></span></p></td>
</tr>
<tr>
<td valign="bottom"><p class="toc1"> </p></td>
<td valign="top"><p class="toc2">Khishigjav Tsogtbaatar, David B. Weishampel, David C. Evans, and Mahito Watabe</p></td>
</tr>
<tr>
<td valign="bottom"><p class="toc1t"><span href="#/xhtml/chapter08#ch8" title="Link target outside of Sample"><strong>8</strong></span></p></td>
<td valign="top"><p class="toc2t"><span href="#/xhtml/chapter08#ch8" title="Link target outside of Sample"><strong>Hadrosauroid Material from the Santonian Milk River Formation of Southern Alberta, Canada</strong></span></p></td>
</tr>
<tr>
<td valign="bottom"><p class="toc1"> </p></td>
<td valign="top"><p class="toc2">Derek W. Larson, Nicolás E. Campione, Caleb M. Brown, David C. Evans, and Michael J. Ryan</p></td>
</tr>
<tr>
<td valign="bottom"><p class="toc1t"> </p></td>
<td valign="top"><p class="toc2t"><strong><span href="#/xhtml/part03#part3" title="Link target outside of Sample">Part 3. Hadrosaurid Anatomy and Variation</span></strong></p></td>
</tr>
<tr>
<td valign="bottom"><p class="toc1t"><span href="#/xhtml/chapter09#ch9" title="Link target outside of Sample"><strong>9</strong></span></p></td>
<td valign="top"><p class="toc2t"><span href="#/xhtml/chapter09#ch9" title="Link target outside of Sample"><strong>New Hadrosaurid (Dinosauria, Ornithopoda) Specimens from the Lower–Middle Campanian Wahweap Formation of Southern Utah</strong></span></p></td>
</tr>
<tr>
<td valign="bottom"><p class="toc1"> </p></td>
<td valign="top"><p class="toc2">Terry A. Gates, Zubair Jinnah, Carolyn Levitt, and Michael A. Getty</p></td>
</tr>
<tr>
<td valign="bottom"><p class="toc1t"><span href="#/xhtml/chapter10#ch10" title="Link target outside of Sample"><strong>10</strong></span></p></td>
<td valign="top"><p class="toc2t"><span href="#/xhtml/chapter10#ch10" title="Link target outside of Sample"><strong>New Saurolophine Material from the Upper Campanian–Lower Maastrichtian Wapiti Formation, West-Central Alberta</strong></span></p></td>
</tr>
<tr>
<td valign="bottom"><p class="toc1"> </p></td>
<td valign="top"><p class="toc2">Phil R. Bell, Robin Sissons, Michael E. Burns, Federico Fanti, and Philip J. Currie</p></td>
</tr>
<tr>
<td valign="bottom"><p class="toc1t"><span href="#/xhtml/chapter11#ch11" title="Link target outside of Sample"><strong>11</strong></span></p></td>
<td valign="top"><p class="toc2t"><span href="#/xhtml/chapter11#ch11" title="Link target outside of Sample"><strong>Variation in the Skull Roof of the Hadrosaur <em>Gryposaurus</em> Illustrated by a New Specimen from the Kaiparowits Formation (late Campanian) of Southern Utah</strong></span></p></td>
</tr>
<tr>
<td valign="bottom"><p class="toc1"> </p></td>
<td valign="top"><p class="toc2">Andrew A. Farke and Lucia Herrero</p></td>
</tr>
<tr>
<td valign="bottom"><p class="toc1t"><span href="#/xhtml/chapter12#ch12" title="Link target outside of Sample"><strong>12</strong></span></p></td>
<td valign="top"><p class="toc2t"><span href="#/xhtml/chapter12#ch12" title="Link target outside of Sample"><strong>A Skull of <em>Prosaurolophus maximus</em> from Southeastern Alberta and the Spatiotemporal Distribution of Faunal Zones in the Dinosaur Park Formation</strong></span></p></td>
</tr>
<tr>
<td valign="bottom"><p class="toc1"> </p></td>
<td valign="top"><p class="toc2">David C. Evans, Christopher T. McGarrity, and Michael J. Ryan</p></td>
</tr>
<tr>
<td valign="bottom"><p class="toc1t"><span href="#/xhtml/chapter13#ch13" title="Link target outside of Sample"><strong>13</strong></span></p></td>
<td valign="top"><p class="toc2t"><span href="#/xhtml/chapter13#ch13" title="Link target outside of Sample"><strong>Postcranial Anatomy of <em>Edmontosaurus regalis</em> (Hadrosauridae) from the Horseshoe Canyon Formation, Alberta, Canada</strong></span></p></td>
</tr>
<tr>
<td valign="bottom"><p class="toc1"> </p></td>
<td valign="top"><p class="toc2">Nicolás E. Campione</p></td>
</tr>
<tr>
<td valign="bottom"><p class="toc1t"><span href="#/xhtml/chapter14#ch14" title="Link target outside of Sample"><strong>14</strong></span></p></td>
<td valign="top"><p class="toc2t"><span href="#/xhtml/chapter14#ch14" title="Link target outside of Sample"><strong>Cranial Morphology and Variation in <em>Hypacrosaurus stebingeri</em> (Ornithischia: Hadrosauridae)</strong></span></p></td>
</tr>
<tr>
<td valign="bottom"><p class="toc1"> </p></td>
<td valign="top"><p class="toc2">Kirstin S. Brink, Darla K. Zelenitsky, David C. Evans, John R. Horner, and François Therrien</p></td>
</tr>
<tr>
<td valign="bottom"><p class="toc1t"> </p></td>
<td valign="top"><p class="toc2t"><strong><span href="#/xhtml/part04#part4" title="Link target outside of Sample">Part 4. Biogeography and Biostratigraphy</span></strong></p></td>
</tr>
<tr>
<td valign="bottom"><p class="toc1t"><span href="#/xhtml/chapter15#ch15" title="Link target outside of Sample"><strong>15</strong></span></p></td>
<td valign="top"><p class="toc2t"><span href="#/xhtml/chapter15#ch15" title="Link target outside of Sample"><strong>An Overview of the Latest Cretaceous Hadrosauroid Record in Europe</strong></span></p></td>
</tr>
<tr>
<td valign="bottom"><p class="toc1"> </p></td>
<td valign="top"><p class="toc2">Fabio M. Dalla Vecchia</p></td>
</tr>
<tr>
<td valign="bottom"><p class="toc1t"><span href="#/xhtml/chapter16#ch16" title="Link target outside of Sample"><strong>16</strong></span></p></td>
<td valign="top"><p class="toc2t"><span href="#/xhtml/chapter16#ch16" title="Link target outside of Sample"><strong>The Hadrosauroid Record in the Maastrichtian of the Eastern Tremp Syncline (Northern Spain)</strong></span></p></td>
</tr>
<tr>
<td valign="bottom"><p class="toc1"> </p></td>
<td valign="top"><p class="toc2">Fabio M. Dalla Vecchia, Rodrigo Gaete, Violeta Riera, Oriol Oms, Albert Prieto-Márquez, Bernat Vila, Albert Garcia Sellés, and Àngel Galobart</p></td>
</tr>
<tr>
<td valign="bottom"><p class="toc1t"><span href="#/xhtml/chapter17#ch17" title="Link target outside of Sample"><strong>17</strong></span></p></td>
<td valign="top"><p class="toc2t"><span href="#/xhtml/chapter17#ch17" title="Link target outside of Sample"><strong>Hadrosaurs from the Far East: Historical Perspective and New <em>Amurosaurus</em> Material from Blagoveschensk (Amur Region, Russia)</strong></span></p></td>
</tr>
<tr>
<td valign="bottom"><p class="toc1"> </p></td>
<td valign="top"><p class="toc2">Yuri L. Bolotsky, Pascal Godefroit, Ivan Y. Bolotsky, and Andrey Atuchin</p></td>
</tr>
<tr>
<td valign="bottom"><p class="toc1t"><span href="#/xhtml/chapter18#ch18" title="Link target outside of Sample"><strong>18</strong></span></p></td>
<td valign="top"><p class="toc2t"><span href="#/xhtml/chapter18#ch18" title="Link target outside of Sample"><strong>South American Hadrosaurs: Considerations on Their Diversity</strong></span></p></td>
</tr>
<tr>
<td valign="bottom"><p class="toc1"> </p></td>
<td valign="top"><p class="toc2">Rodolfo A. Coria</p></td>
</tr>
<tr>
<td valign="bottom"><p class="toc1t"><span href="#/xhtml/chapter19#ch19" title="Link target outside of Sample"><strong>19</strong></span></p></td>
<td valign="top"><p class="toc2t"><span href="#/xhtml/chapter19#ch19" title="Link target outside of Sample"><strong>The Hadrosaurian Record from Mexico</strong></span></p></td>
</tr>
<tr>
<td valign="bottom"><p class="toc1"> </p></td>
<td valign="top"><p class="toc2">Angel A. Ramírez-Velasco, René Hernández-Rivera, and Ricardo Servin-Pichardo</p></td>
</tr>
<tr>
<td valign="bottom"><p class="toc1t"><span href="#/xhtml/chapter20#ch20" title="Link target outside of Sample"><strong>20</strong></span></p></td>
<td valign="top"><p class="toc2t"><span href="#/xhtml/chapter20#ch20" title="Link target outside of Sample"><strong>Stratigraphic Distribution of Hadrosaurids in the Upper Cretaceous Fruitland, Kirtland, and Ojo Alamo Formations, San Juan Basin, New Mexico</strong></span></p></td>
</tr>
<tr>
<td valign="bottom"><p class="toc1"> </p></td>
<td valign="top"><p class="toc2">Robert M. Sullivan and Spencer G. Lucas</p></td>
</tr>
<tr>
<td valign="bottom"><p class="toc1t"><span href="#/xhtml/chapter21#ch21" title="Link target outside of Sample"><strong>21</strong></span></p></td>
<td valign="top"><p class="toc2t"><span href="#/xhtml/chapter21#ch21" title="Link target outside of Sample"><strong>Relocating the Lost <em>Gryposaurus incurvimanus</em> Holotype Quarry, Dinosaur Provincial Park, Alberta, Canada</strong></span></p></td>
</tr>
<tr>
<td valign="bottom"><p class="toc1"> </p></td>
<td valign="top"><p class="toc2">Darren H. Tanke and David C. Evans</p></td>
</tr>
<tr>
<td valign="bottom"><p class="toc1t"> </p></td>
<td valign="top"><p class="toc2t"><a id="page_viii"></a><strong><span href="#/xhtml/part05#part5" title="Link target outside of Sample">Part 5. Function and Growth</span></strong></p></td>
</tr>
<tr>
<td valign="bottom"><p class="toc1t"><span href="#/xhtml/chapter22#ch22" title="Link target outside of Sample"><strong>22</strong></span></p></td>
<td valign="top"><p class="toc2t"><span href="#/xhtml/chapter22#ch22" title="Link target outside of Sample"><strong>Comparative Ontogenies (Appendicular Skeleton) for Three Hadrosaurids and a Basal Iguanodontian: Divergent Developmental Pathways in Hadrosaurinae and Lambeosaurinae</strong></span></p></td>
</tr>
<tr>
<td valign="bottom"><p class="toc1"> </p></td>
<td valign="top"><p class="toc2">Merrilee F. Guenther</p></td>
</tr>
<tr>
<td valign="bottom"><p class="toc1t"><span href="#/xhtml/chapter23#ch23" title="Link target outside of Sample"><strong>23</strong></span></p></td>
<td valign="top"><p class="toc2t"><span href="#/xhtml/chapter23#ch23" title="Link target outside of Sample"><strong>The Size-Frequency Distribution of Hadrosaurs from the Dinosaur Park Formation of Alberta, Canada</strong></span></p></td>
</tr>
<tr>
<td valign="bottom"><p class="toc1"> </p></td>
<td valign="top"><p class="toc2">Donald B. Brinkman</p></td>
</tr>
<tr>
<td valign="bottom"><p class="toc1t"><span href="#/xhtml/chapter24#ch24" title="Link target outside of Sample"><strong>24</strong></span></p></td>
<td valign="top"><p class="toc2t"><span href="#/xhtml/chapter24#ch24" title="Link target outside of Sample"><strong>Osteohistology and Occlusal Morphology of <em>Hypacrosaurus stebingeri</em> Teeth throughout Ontogeny with Comments on Wear-Induced Form and Function</strong></span></p></td>
</tr>
<tr>
<td valign="bottom"><p class="toc1"> </p></td>
<td valign="top"><p class="toc2">Gregory M. Erickson and Darla K. Zelenitsky</p></td>
</tr>
<tr>
<td valign="bottom"><p class="toc1t"><span href="#/xhtml/chapter25#ch25" title="Link target outside of Sample"><strong>25</strong></span></p></td>
<td valign="top"><p class="toc2t"><span href="#/xhtml/chapter25#ch25" title="Link target outside of Sample"><strong>Three-Dimensional Computational Modeling of Pelvic Locomotor Muscle Moment Arms in <em>Edmontosaurus</em> (Dinosauria, Hadrosauridae) and Comparisons with Other Archosaurs</strong></span></p></td>
</tr>
<tr>
<td valign="bottom"><p class="toc1"> </p></td>
<td valign="top"><p class="toc2">Susannah C. R. Maidment, Karl T. Bates, and Paul M. Barrett</p></td>
</tr>
<tr>
<td valign="bottom"><p class="toc1t"><span href="#/xhtml/chapter26#ch26" title="Link target outside of Sample"><strong>26</strong></span></p></td>
<td valign="top"><p class="toc2t"><span href="#/xhtml/chapter26#ch26" title="Link target outside of Sample"><strong>Duckbills on the Run: The Cursorial Abilities of Hadrosaurs and Implications for Tyrannosaur-Avoidance Strategies</strong></span></p></td>
</tr>
<tr>
<td valign="bottom"><p class="toc1"> </p></td>
<td valign="top"><p class="toc2">W. Scott Persons IV and Philip J. Currie</p></td>
</tr>
<tr>
<td valign="bottom"><p class="toc1t"><span href="#/xhtml/chapter27#ch27" title="Link target outside of Sample"><strong>27</strong></span></p></td>
<td valign="top"><p class="toc2t"><span href="#/xhtml/chapter27#ch27" title="Link target outside of Sample"><strong>Duck Soup: The Floating Fates of Hadrosaurs and Ceratopsians at Dinosaur Provincial Park</strong></span></p></td>
</tr>
<tr>
<td valign="bottom"><p class="toc1"> </p></td>
<td valign="top"><p class="toc2">Donald M. Henderson</p></td>
</tr>
<tr>
<td valign="bottom"><p class="toc1t"><span href="#/xhtml/chapter28#ch28" title="Link target outside of Sample"><strong>28</strong></span></p></td>
<td valign="top"><p class="toc2t"><span href="#/xhtml/chapter28#ch28" title="Link target outside of Sample"><strong>Hadrosauroid Jaw Mechanics and the Functional Significance of the Predentary Bone</strong></span></p></td>
</tr>
<tr>
<td valign="bottom"><p class="toc1"> </p></td>
<td valign="top"><p class="toc2">Ali Nabavizadeh</p></td>
</tr>
<tr>
<td valign="bottom"><p class="toc1t"> </p></td>
<td valign="top"><p class="toc2t"><strong><span href="#/xhtml/part06#part6" title="Link target outside of Sample">Part 6. Preservation, Tracks, and Traces</span></strong></p></td>
</tr>
<tr>
<td valign="bottom"><p class="toc1t"><span href="#/xhtml/chapter29#ch29" title="Link target outside of Sample"><strong>29</strong></span></p></td>
<td valign="top"><p class="toc2t"><span href="#/xhtml/chapter29#ch29" title="Link target outside of Sample"><strong>Debris Flow Origin of an Unusual Late Cretaceous Hadrosaur Bonebed in the Two Medicine Formation of Western Montana</strong></span></p></td>
</tr>
<tr>
<td valign="bottom"><p class="toc1"> </p></td>
<td valign="top"><p class="toc2">James G. Schmitt, Frankie D. Jackson, and Rebecca R. Hanna</p></td>
</tr>
<tr>
<td valign="bottom"><p class="toc1t"><span href="#/xhtml/chapter30#ch30" title="Link target outside of Sample"><strong>30</strong></span></p></td>
<td valign="top"><p class="toc2t"><span href="#/xhtml/chapter30#ch30" title="Link target outside of Sample"><strong>Occurrence and Taphonomy of the First Documented Hadrosaurid Bonebed from the Dinosaur Park Formation (Belly River Group, Campanian) at Dinosaur Provincial Park, Alberta, Canada</strong></span></p></td>
</tr>
<tr>
<td valign="bottom"><p class="toc1"> </p></td>
<td valign="top"><p class="toc2">David A. Eberth, David C. Evans, and David W. H. Lloyd</p></td>
</tr>
<tr>
<td valign="bottom"><p class="toc1t"><span href="#/xhtml/chapter31#ch31" title="Link target outside of Sample"><strong>31</strong></span></p></td>
<td valign="top"><p class="toc2t"><span href="#/xhtml/chapter31#ch31" title="Link target outside of Sample"><strong>Body Size Distribution in a Death Assemblage of a Colossal Hadrosaurid from the Upper Cretaceous of Zhucheng, Shandong Province, China</strong></span></p></td>
</tr>
<tr>
<td valign="bottom"><p class="toc1"> </p></td>
<td valign="top"><p class="toc2">David W. E. Hone, Corwin Sullivan, Qi Zhao, Kebai Wang, and Xing Xu</p></td>
</tr>
<tr>
<td valign="bottom"><p class="toc1t"><span href="#/xhtml/chapter32#ch32" title="Link target outside of Sample"><strong>32</strong></span></p></td>
<td valign="top"><p class="toc2t"><span href="#/xhtml/chapter32#ch32" title="Link target outside of Sample"><strong>First Hadrosaur Trackway from the Upper Cretaceous (Late Campanian) Oldman Formation, Southeastern Alberta</strong></span></p></td>
</tr>
<tr>
<td valign="bottom"><p class="toc1"> </p></td>
<td valign="top"><p class="toc2">François Therrien, Darla K. Zelenitsky, Kohei Tanaka, and Wendy J. Sloboda</p></td>
</tr>
<tr>
<td valign="bottom"><p class="toc1t"><span href="#/xhtml/chapter33#ch33" title="Link target outside of Sample"><strong>33</strong></span></p></td>
<td valign="top"><p class="toc2t"><span href="#/xhtml/chapter33#ch33" title="Link target outside of Sample"><strong>Paleopathology in Late Cretaceous Hadrosauridae from Alberta, Canada</strong></span></p></td>
</tr>
<tr>
<td valign="bottom"><p class="toc1"> </p></td>
<td valign="top"><p class="toc2">Darren H. Tanke and Bruce M. Rothschild</p></td>
</tr>
<tr>
<td valign="bottom"><p class="toc1t"><span href="#/xhtml/chapter34#ch34" title="Link target outside of Sample"><strong>34</strong></span></p></td>
<td valign="top"><p class="toc2t"><span href="#/xhtml/chapter34#ch34" title="Link target outside of Sample"><strong>A Review of Hadrosaurid Skin Impressions</strong></span></p></td>
</tr>
<tr>
<td valign="bottom"><p class="toc1"> </p></td>
<td valign="top"><p class="toc2">Phil R. Bell</p></td>
</tr>
<tr>
<td valign="bottom"><p class="toc1t"><span href="#/xhtml/chapter35#ch35" title="Link target outside of Sample"><strong>35</strong></span></p></td>
<td valign="top"><p class="toc2t"><span href="#/xhtml/chapter35#ch35" title="Link target outside of Sample"><strong>Soft-Tissue Structures of the Nasal Vestibular Region of Saurolophine Hadrosaurids (Dinosauria, Ornithopoda) Revealed in a “Mummified” Specimen of <em>Edmontosaurus annectens</em></strong></span></p></td>
</tr>
<tr>
<td valign="bottom"><p class="toc1"> </p></td>
<td valign="top"><p class="toc2">Albert Prieto-Márquez and Jonathan R. Wagner</p></td>
</tr>
<tr>
<td valign="bottom"><p class="toc1t"><span href="#/xhtml/chapter36#ch36" title="Link target outside of Sample"><strong>36</strong></span></p></td>
<td valign="top"><p class="toc2t"><span href="#/xhtml/chapter36#ch36" title="Link target outside of Sample"><strong>The Role and Biochemistry of Melanin Pigment in the Exceptional Preservation of Hadrosaur Skin</strong></span></p></td>
</tr>
<tr>
<td valign="bottom"><p class="toc1"> </p></td>
<td valign="top"><p class="toc2">Phillip L. Manning, Roy A. Wogelius, Bart Van Dongen, Tyler R. Lyson, Uwe Bergmann, Sam Webb, Michael Buckley, Victoria M. Egerton, and William I. Sellers</p></td>
</tr>
<tr>
<td valign="bottom"><p class="toc2t"> </p></td>
<td valign="top"><p class="toc2t"><span href="#/xhtml/afterword#aft" title="Link target outside of Sample">Afterword</span> · John R. Horner</p></td>
</tr>
<tr>
<td valign="bottom"><p class="toc2t"> </p></td>
<td valign="top"><p class="toc2t"><span href="#/xhtml/index01#sub" title="Link target outside of Sample">Subject Index</span></p></td>
</tr>
<tr>
<td valign="bottom"><p class="toc2t"> </p></td>
<td valign="top"><p class="toc2t"><span href="#/xhtml/index02#loc" title="Link target outside of Sample">Locality Index (by country)</span></p></td>
</tr>
<tr>
<td valign="bottom"><p class="toc2t"> </p></td>
<td valign="top"><p class="toc2t"><span href="#/xhtml/index03#str" title="Link target outside of Sample">Stratigraphy Index (by country)</span></p></td>
</tr>
<tr>
<td valign="bottom"><p class="toc1t"> </p></td>
<td valign="top"><p class="toc2t"><span href="#/xhtml/index04#tax" title="Link target outside of Sample">Taxonomic Index</span></p></td>
</tr>
</tbody></table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?7cd095e8